import { MetricsService, MyService } from '@/api/EvocallService'
import { AppointmentService } from '@/api/AuthClinicalService'
import EventBus from '@/utils/EventBus'

const INITIALIZE_MODULE = ({ dispatch, commit, state }, { clinicalServiceId, clinicalServiceUrl }) => {
  commit('SET_AUTH_CLINICAL_SERVICE', { id: clinicalServiceId, url: clinicalServiceUrl })
  if (!state.isLoading) {
    commit('SET_LOADING', { isLoading: true })
    //dispatch('LOAD_ACTIVE_APPOINTMENTS')
    //dispatch('LOAD_ONGOING_REQUEST')
    //dispatch('LOAD_ACTIVE_BREAK')
    //dispatch('LOAD_ONLINE_AUDIOLOGISTS')
  }
}

const RELOAD_MODULE = ({ dispatch, commit, state }) => {
  if (!state.isLoading) {
    commit('SET_LOADING', { isLoading: true })
    //dispatch('LOAD_ACTIVE_APPOINTMENTS')
    //dispatch('LOAD_ACTIVE_APPOINTMENTS')
    //dispatch('LOAD_ONGOING_REQUEST')
    //dispatch('LOAD_ONLINE_AUDIOLOGISTS')
    //dispatch('LOAD_ACTIVE_BREAK')
  }
}

const LOAD_ACTIVE_APPOINTMENTS = ({ commit, state }) => {
  if (state.authClinicalService === null) {
    throw new Error('Waiting Room Module: Attempt to fetch active-appointments appointment, but no Auth Clinical Service defined')
  }

  AppointmentService.getUserActiveAppointment(state.authClinicalService.url)
    .then(appointments => commit('SET_ACTIVE_APPOINTMENTS', { appointments: appointments }))
    .catch(errors => console.log(errors))
}

const LOAD_ONGOING_REQUEST = ({ commit, state, dispatch }) => {
  commit('RESET_ACTIVE_REQUEST')
  commit('RESET_PENDING_REQUEST')

  MyService.getPendingRequest({ serviceId: state.authClinicalService.id })
    .then(request => {
      if (request) {
        dispatch('LOAD_PENDING_REQUEST_APPOINTMENT', { appointment_id: request.appointment_id })
        commit('SET_PENDING_REQUEST_CALL', { call: request })
        commit('SET_LOADING', { isLoading: false })
      } else {
        MyService.getActiveRequest({ serviceId: state.authClinicalService.id })
          .then(request => {
            if (request) {
              dispatch('LOAD_ACTIVE_REQUEST_APPOINTMENT', { appointment_id: request.appointment_id })
              commit('SET_ACTIVE_REQUEST_CALL', { call: request })
            }
          })
          .catch(errors => console.log(errors))
          .finally(() => commit('SET_LOADING', { isLoading: false }))
      }
    })
    .catch(errors => {
      console.log(errors)
      commit('SET_LOADING', { isLoading: false })
    })
}

const LOAD_ACTIVE_BREAK = function () {
  this._vm.$socket.emit('GET_ACTIVE_BREAK')
}

const LOAD_ONLINE_AUDIOLOGISTS = function () {
  this._vm.$socket.emit('GET_ONLINE_AUDIOLOGISTS')
}

// eslint-disable-next-line camelcase
const LOAD_PENDING_REQUEST_APPOINTMENT = ({ commit, state }, { appointment_id }) => {
  if (state.authClinicalService === null) {
    throw new Error('Waiting Room Module: Attempt to load pending request appointment, but no Auth Clinical Service defined')
  }

  AppointmentService.get(state.authClinicalService.url, appointment_id)
    .then(appointment => {
      commit('SET_PENDING_REQUEST_APPOINTMENT', { appointment })
      commit('SET_CURRENT_ACTIVE_APPOINTMENT', { appointment: state.activeAppointments.find(item => item.id === appointment.parent_id) })
    })
    .catch(errors => console.log(errors))
}

// eslint-disable-next-line camelcase
const LOAD_ACTIVE_REQUEST_APPOINTMENT = ({ commit, state }, { appointment_id }) => {
  if (state.authClinicalService === null) {
    throw new Error('Waiting Room Module: Attempt to load active-appointments request appointment, but no Auth Clinical Service defined')
  }

  AppointmentService.get(state.authClinicalService.url, appointment_id)
    .then(appointment => {
      commit('SET_ACTIVE_REQUEST_APPOINTMENT', { appointment })
      commit('RESET_PENDING_REQUEST')
      commit('SET_CURRENT_ACTIVE_APPOINTMENT', { appointment: state.activeAppointments.find(item => item.id === appointment.parent_id) })
    })
    .catch(errors => console.log(errors))
}

const GET_METRICS = ({ commit, state }) => {
  MetricsService.query({ serviceId: state.authClinicalService.id })
    .then(data => {
      commit('METRICS_UPDATED', data)
    }).catch(errors => {
      console.log(errors)
    })
}

const SOCKET_ONLINE_AUDIOLOGISTS_UPDATED = ({ commit }, payload) => {
  commit('SET_ONLINE_AUDIOLOGISTS', payload)
}

const SOCKET_SET_ACTIVE_BREAK = ({ commit }, { _break }) => {
  commit('SET_ACTIVE_BREAK', { _break })
}

/* Call Request Handling */

const SOCKET_REQUEST_STARTED = ({ commit, dispatch, state }, { request }) => {
  if (state.authClinicalService.id === request.service_id) {
    commit('SET_PENDING_REQUEST_CALL', { call: request })
    dispatch('LOAD_PENDING_REQUEST_APPOINTMENT', { appointment_id: request.appointment_id })
  }
}

const SOCKET_REQUEST_ACCEPT_TIME_UPDATED = ({ commit, state }, { request }) => {
  if (state.authClinicalService.id === request.service_id) {
    commit('UPDATE_PENDING_REQUEST_CALL_WAITING_TIME', { estimatedAcceptTime: request.estimated_accept_time })
  }
}

const SOCKET_REQUEST_CANCELED = ({ commit, state }, { request }) => {
  if (state.authClinicalService.id === request.service_id) {
    commit('RESET_PENDING_REQUEST')
  }
}

const SOCKET_REQUEST_ACCEPTED = ({ commit, dispatch, state }, { request }) => {
  if (state.authClinicalService.id === request.service_id) {
    commit('SET_ACTIVE_REQUEST_CALL', { call: request })
    dispatch('LOAD_ACTIVE_REQUEST_APPOINTMENT', { appointment_id: request.appointment_id })
  }
}

const SOCKET_REQUEST_REQUEUED = ({ commit, dispatch, state }, { request }) => {
  if (state.authClinicalService.id === request.service_id) {
    commit('SET_PENDING_REQUEST_CALL', { call: request })
    dispatch('LOAD_PENDING_REQUEST_APPOINTMENT', { appointment_id: request.appointment_id })
    commit('RESET_ACTIVE_REQUEST')
  }
}

const SOCKET_REQUEST_RATED_AUDIOLOGIST = ({ commit, state }, { request }) => {
  if (state.authClinicalService.id === request.service_id) {
    EventBus.$emit('CLOSE_RATE_MODAL_AUDIOLOGIST', request)
  }
}

const SOCKET_REQUEST_ENDED = ({ commit, state }, { request }) => {
  if (state.authClinicalService.id === request.service_id) {
    commit('SET_ACTIVE_REQUEST_CALL', { call: request })
  }
}

/** Important: To access _vm we cannot use an anonymous function **/
const ACTIVE_REQUEST_CHANGES_SAVED = function ({ state }, { field }) {
  if (state.activeRequest !== null) {
    this._vm.$socket.emit('active-request-appointment-updated', { appointment_id: state.activeRequest.appointment.id, request_id: state.activeRequest.call.id, field })
  }
}

/* Waiting Room Queue */
const SOCKET_QUEUE_ITEMS = ({ commit, state, dispatch }, { items, serviceId }) => {
  if (serviceId === state.authClinicalService.id) {
    dispatch('GET_METRICS')
    commit('SET_REQUESTS', { requests: items })
  }
}

const SOCKET_QUEUE_ITEM_ENDED = ({ dispatch }) => {
  dispatch('GET_METRICS')
}

const SOCKET_QUEUE_ITEM_CREATED = ({ commit, state }, { request }) => {
  if (request.service_id === state.authClinicalService.id) {
    commit('REQUEST_CREATED', { request })
  }
}

const SOCKET_QUEUE_ITEM_UPDATED = ({ dispatch, commit, state }, { request }) => {
  if (request.service_id === state.authClinicalService.id) {
    dispatch('GET_METRICS')
    commit('REQUEST_UPDATED', { request })
  }
}

const SOCKET_QUEUE_ITEM_CANCELED = ({ dispatch, commit, state }, { request }) => {
  if (request.service_id === state.authClinicalService.id) {
    dispatch('GET_METRICS')
    commit('REQUEST_DELETED', { request })
  }
}

const SOCKET_QUEUE_ITEM_DELETED = ({ dispatch, commit, state }, { request }) => {
  if (request.service_id === state.authClinicalService.id) {
    dispatch('GET_METRICS')
    commit('REQUEST_DELETED', { request })
  }
}

const SOCKET_QUEUE_ITEMS_UPDATED = ({ dispatch, commit, state }, { requests }) => {
  requests = requests.filter(r => r.service_id === state.authClinicalService.id)
  dispatch('GET_METRICS')
  commit('REQUESTS_UPDATED', { requests })
}

const RESET_MODULE = ({ commit }) => {
  commit('RESET_ACTIVE_REQUEST')
  commit('RESET_PENDING_REQUEST')
  commit('RESET_ONLINE_AUDIOLOGISTS')
  commit('RESET_ACTIVE_BREAK')
  commit('RESET_REQUESTS')
}

export default {
  INITIALIZE_MODULE,
  LOAD_ONGOING_REQUEST,
  LOAD_ACTIVE_BREAK,
  LOAD_ACTIVE_APPOINTMENTS,
  LOAD_ONLINE_AUDIOLOGISTS,
  GET_METRICS,
  RESET_MODULE,
  RELOAD_MODULE,
  SOCKET_ONLINE_AUDIOLOGISTS_UPDATED,
  SOCKET_SET_ACTIVE_BREAK,
  SOCKET_QUEUE_ITEMS,
  SOCKET_QUEUE_ITEM_ENDED,
  SOCKET_QUEUE_ITEM_CREATED,
  SOCKET_QUEUE_ITEM_UPDATED,
  SOCKET_QUEUE_ITEM_DELETED,
  SOCKET_QUEUE_ITEM_CANCELED,
  SOCKET_QUEUE_ITEMS_UPDATED,
  LOAD_PENDING_REQUEST_APPOINTMENT,
  LOAD_ACTIVE_REQUEST_APPOINTMENT,
  SOCKET_REQUEST_STARTED,
  SOCKET_REQUEST_CANCELED,
  SOCKET_REQUEST_ACCEPTED,
  SOCKET_REQUEST_REQUEUED,
  SOCKET_REQUEST_RATED_AUDIOLOGIST,
  SOCKET_REQUEST_ENDED,
  SOCKET_REQUEST_ACCEPT_TIME_UPDATED,
  ACTIVE_REQUEST_CHANGES_SAVED,
}
